<template>
  <div class="chartNum">
    <div class="box-item">
      <!-- 判断是否是数字  (逗号不需要框) -->
      <li
        :class="{ 'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
        v-for="(item, index) in orderNum"
        :key="index"
      >
        <span v-if="!isNaN(item)">
          <!-- 每个数字对应的 0-9 的滚动列表，使数字竖直排列向上滚动 最终定位在对应的数字上 -->
          <i ref="numberItem">0123456789</i>
        </span>
        <span class="comma" v-else>{{ item }}</span>
      </li>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number, // 具体数值
      default() {
        return 0;
      },
    },
    time: {
      type: Number, // 滚动开始时间
      default() {
        return 3;
      },
    },
  },
  data() {
    return {
      orderNum: ["0", "0", "0", "0", "0", "0", "0"],
    };
  },
  mounted() {
    // this.toOrderNum(4564); // 这里输入数字即可调用
    // this.increaseNumber(this.time);
  },
  watch: {
    value(val) {
      this.toOrderNum(val);
      this.setNumberTransform();
    },
  },
  methods: {
    // 定时增长数字
    increaseNumber(time) {
      let self = this;
      this.timer = setInterval(() => {
        self.setNumberTransform();
      }, time * 1000);
    },
    // 设置文字滚动
    setNumberTransform() {
      const numberItems = this.$refs.numberItem; // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum.filter((item) => !isNaN(item));
      //   console.log(numberArr);
      // 结合CSS 对数字字符进行滚动显示
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        // 每位数字对应偏移量
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    },
    // 处理传过来的具体值value
    toOrderNum(num) {
      num = num.toString();
      // 把具体值value变成字符串
      if (num.length < 7) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum(num); // 递归添加"0"补位
      } else if (num.length === 7) {
        // 具体值value中加入逗号
        num = num.slice(0, 2) + "" + num.slice(2, 5) + "" + num.slice(5, 7);
        this.orderNum = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 具体值value数字超过八位显示异常
        this.$message.warning("xxx数量过大，显示异常，请联系后台管理员");
      }
    },
  },
};
</script>
<style scoped lang="scss">
/*具体值value总量滚动数字设置*/
/* prettier-ignore */
.chartNum{
  
.box-item {
  position: relative;
  height: 100PX;
  font-size: 54PX;
  line-height: 41PX;
  text-align: center;
  list-style: none;
  color: #fff;
  //   writing-mode: vertical-lr;
  //   text-orientation: upright;
  overflow: hidden;
  display: flex;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  font-weight: bold;
}
/* 默认逗号设置 */
.mark-item {
  width: 10PX;
  height: 90PX;
  margin-right: 5PX;
  line-height: 10PX;
  font-size: 48PX;
  position: relative;
  & > span {
    position: absolute;
    width: 100%;
    bottom: 0;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }
}
/*滚动数字设置*/
.number-item {
  width: 41PX;
  height: 75PX;
  list-style: none;
  margin-right: 23PX;
  background: #327BFF;
  border-radius: 4PX;
  border: 1px solid #327BFF;
  & > span {
    position: relative;
    display: inline-block;
    margin-right: 10PX;
    width: 100%;
    height: 100%;
    writing-mode: tb-rl; // writing-mode 改变文字排列方向
    text-orientation: upright; // 文字方向
    overflow: hidden;
    & > i {
      font-style: normal;
      position: absolute;
      top: 11PX;
      left: 50%;
      transform: translate(-50%, 0);
      transition: transform 1s ease-in-out;
      letter-spacing: 10PX;
    }
  }
}
.number-item:last-child {
  margin-right: 0;
}
}
</style>
